// Slick Carousel - Auto Play
/*
import Glide from "@glidejs/glide";

class CarouselHeroCaption {
  constructor() {
    // element that will be wrapped
    const carousel = document.querySelector(".carousel-hero-caption");

    if (carousel) {
      const carouselTrack = document.querySelector(
        ".carousel-hero-caption .wp-block-group"
      );
      const carouselSlides = carouselTrack.querySelector(
        ".carousel-hero-caption .wp-block-group .wp-block-group"
      );
      const carouselIndividualSlide = carouselTrack.querySelectorAll(
        ".carousel-hero-caption .wp-block-group .wp-block-group .wp-block-cover"
      );

      // Add Glide classes
      carouselTrack.classList.add("glide__track");
      carouselTrack.dataset.glideEl = "track";
      carouselSlides.classList.add("glide__slides");
      carouselIndividualSlide.forEach((item) => {
        item.classList.add("glide__slide");
      });

      // Tweak styles
      carousel.style.overflow = "hidden";
      carouselSlides.style.flexWrap = "nowrap";

      var fullWidthGlide = new Glide(".carousel-hero-caption", {
        type: "carousel",
        perView: 1,
        autoplay: 4000,
        peek: 0,
        gap: 0,
      }).mount();
    }
  }
}

export default CarouselHeroCaption;
*/

// Slick Carousel - change image when Refreshing page
import Glide from "@glidejs/glide";

class CarouselHeroCaption {
  constructor() {
    const carousel = document.querySelector(".carousel-hero-caption");

    if (carousel) {
      const carouselTrack = document.querySelector(".carousel-hero-caption .wp-block-group");
      const carouselSlides = carouselTrack.querySelector(".carousel-hero-caption .wp-block-group .wp-block-group");
      const carouselIndividualSlide = carouselTrack.querySelectorAll(".carousel-hero-caption .wp-block-group .wp-block-group .wp-block-cover");

      carouselTrack.classList.add("glide__track");
      carouselTrack.dataset.glideEl = "track";
      carouselSlides.classList.add("glide__slides");
      carouselIndividualSlide.forEach((item) => {
        item.classList.add("glide__slide");
      });

      carousel.style.overflow = "hidden";
      carouselSlides.style.flexWrap = "nowrap";

      var fullWidthGlide = new Glide(".carousel-hero-caption", {
        type: "carousel",
        perView: 1,
        peek: 0,
        gap: 0,
      }).mount();

      const totalSlides = 4 //fullWidthGlide.length;
      
      let lastSeenSlide = localStorage.getItem('lastSeenSlide');

      if (lastSeenSlide === null) {
        lastSeenSlide = 0;
      } else {
        lastSeenSlide = Number(lastSeenSlide) + 1;

        if (lastSeenSlide >= totalSlides) {
          lastSeenSlide = 0;
        }
      }

      fullWidthGlide.go(`=${lastSeenSlide}`);
      localStorage.setItem('lastSeenSlide', lastSeenSlide);
    }
  }
}

export default CarouselHeroCaption;
